import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b929a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "table-wrapper" }
const _hoisted_3 = { class: "row align-items-center table-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "col-6 title" }, "Users", -1))
const _hoisted_5 = { class: "col align-middle" }
const _hoisted_6 = { class: "search input-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" })
], -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "table-scroll-view" }
const _hoisted_10 = { class: "table table-striped table-bordered" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "align-middle" }, [
  /*#__PURE__*/_createElementVNode("th", null, "#"),
  /*#__PURE__*/_createElementVNode("th", null, "Email"),
  /*#__PURE__*/_createElementVNode("th", null, "Role"),
  /*#__PURE__*/_createElementVNode("th", null, "Provider"),
  /*#__PURE__*/_createElementVNode("th", null, "Tag"),
  /*#__PURE__*/_createElementVNode("th", null, "Created"),
  /*#__PURE__*/_createElementVNode("th", null, "Modified"),
  /*#__PURE__*/_createElementVNode("th", null, "Actions")
], -1))
const _hoisted_12 = { class: "align-middle" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "table-footer" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "pagination" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "page-link",
  href: "#"
}, " Previous ", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "page-link selector" }
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "page-link",
  href: "#"
}, " Next ", -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_edit_modal = _resolveComponent("user-edit-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.fetch()), ["enter"])),
                disabled: _ctx.disabled,
                placeholder: "Search"
              }, null, 40, _hoisted_8), [
                [_vModelText, _ctx.query]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("th", null, _toDisplayString(user.id), 1),
                  _createElementVNode("td", null, _toDisplayString(user.email), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", {
                    'bg-danger': user.admin,
                    'bg-secondary': !user.admin
                  }])
                    }, _toDisplayString(user.role), 3)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(user.provider), 1),
                  _createElementVNode("td", null, _toDisplayString(user.tag?.name), 1),
                  _createElementVNode("td", null, _toDisplayString(user.created.toLocaleString()), 1),
                  _createElementVNode("td", null, _toDisplayString(user.modified.toLocaleString()), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "action-btn btn-sm btn btn-primary",
                      onClick: ($event: any) => (_ctx.editUser(user.id)),
                      type: "button",
                      title: "Edit user"
                    }, _hoisted_15, 8, _hoisted_13)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.pages.length)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_17, [
                _createElementVNode("ul", _hoisted_18, [
                  _createElementVNode("li", {
                    class: _normalizeClass(["page-item", {'disabled': _ctx.disabled || !_ctx.isPrevPage}]),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                  }, _hoisted_20, 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(["page-item", {'disabled': _ctx.disabled}])
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("input", {
                        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToPage && _ctx.goToPage(...args))),
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goToPage && _ctx.goToPage(...args)), ["enter"])),
                        value: _ctx.pageSelector
                      }, null, 40, _hoisted_22),
                      _createTextVNode(" of " + _toDisplayString(_ctx.pages.length), 1)
                    ])
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(["page-item", {'disabled': _ctx.disabled || !_ctx.isNextPage}]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nextPage()))
                  }, _hoisted_24, 2)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_user_edit_modal, {
      onSuccess: _ctx.closed,
      ref: "modal"
    }, null, 8, ["onSuccess"])
  ], 64))
}